import { Link } from '@tanstack/react-router';
import type { TabItem } from './nav';
import { Icon } from './icons';

export interface BottomTabsProps {
  tabs: readonly TabItem[];
  onSearch: () => void;
  onMore: () => void;
  moreOpen: boolean;
}

/**
 * Phone only. 56px, safe area aware, 44px targets.
 *
 * The glyph is decorative and aria-hidden. The label under it is the accessible name, which
 * is why the tabs stay readable to a screen reader and to anyone who has never met this icon
 * set before.
 */
export function BottomTabs({ tabs, onSearch, onMore, moreOpen }: BottomTabsProps) {
  return (
    <nav className="o-tabbar" aria-label="Sections">
      {tabs.map((tab) => {
        const glyph = (
          <span className="o-tabbar__icon" aria-hidden="true">
            <Icon name={tab.icon} {...(tab.action === 'more' ? { turn: 90 } : {})} />
          </span>
        );

        if (tab.action === 'search') {
          return (
            <button key={tab.id} type="button" className="o-tabbar__item" onClick={onSearch}>
              {glyph}
              <span className="o-tabbar__label">{tab.label}</span>
            </button>
          );
        }
        if (tab.action === 'more') {
          return (
            <button
              key={tab.id}
              type="button"
              className="o-tabbar__item"
              aria-expanded={moreOpen}
              onClick={onMore}
            >
              {glyph}
              <span className="o-tabbar__label">{tab.label}</span>
            </button>
          );
        }
        return (
          <Link
            key={tab.id}
            to={tab.href ?? '/'}
            className="o-tabbar__item"
            activeOptions={{ exact: tab.href === '/' }}
          >
            {glyph}
            <span className="o-tabbar__label">{tab.label}</span>
          </Link>
        );
      })}
    </nav>
  );
}
